<template>
  <div>

    <ConfirmModal ref="userRemoveModal" :okButtonText="$t('message.delete')"
                  @ok-handle="deleteFromDatabase"></ConfirmModal>

    <ConfirmModal id="change-role-confirm" ref="change-role-confirm"
                  :okButtonText="$t('message.approve_change_role_button')"
                  @ok-handle="requestConfirm" @cancel-handle="reloadUsers"></ConfirmModal>

    <Breadcrumbs :title="project ? project.translation['en'].name + ' / Team' : '&nbsp;'"/>

    <UsersModal ref="usersModal"></UsersModal>
    <DeleteModal ref="deleteModal"></DeleteModal>
    <div class="col-xl-12 xl-100 box-col-12 mb-3">
      <div class="text-right" v-if="canEdit">
        <button @click="openUserModal" type="button" class="btn btn-primary"><i data-feather="plus-square"></i>
          {{ $t('message.project_team_user_invite') }}
        </button>
      </div>
    </div>

    <div class="col-xl-12 xl-100 box-col-12">
      <div class="card">
        <div class="card-header">
          <h5>{{ $t('message.project_team') }}</h5>
        </div>
        <div class="card-body">

          <div class="container-fluid">
            <div class="row user-cards">
              <div class="col-md-4 col-lg-4 col-xl-3" v-for="record in users" :key="record.id">
                <div class="card custom-card">
                  <div class="card-header"
                       style="background-color: #7366ff;margin: -10px -10px 20px;"></div>
                  <div class="card-profile"><img class="rounded-circle" :src="record.user.image"
                                                 alt=""></div>

                  <div class="text-center profile-details">
                    <h4 style="overflow: hidden; text-overflow: ellipsis;white-space: nowrap;height: 30px;">{{ record.user.name == '' ?  'N/A' : record.user.name }}</h4>
                    <h6 style="font-size: 12px;">{{ record.user.email }}</h6>
                  </div>
                  <div class="card-footer row">
                    <div class="col-10 col-sm-10"
                         :class="{'col-12' : !canEdit || user.id == record.user.id, 'col-sm-12' : !canEdit || user.id == record.user.id}">
                      <b-select v-model="record.role"
                                :disabled="user.id == record.user.id || !canEdit"
                                @change="changeRole(record, $event)">
                        <b-form-select-option value="creator">{{
                            $t('message.editor')
                          }}
                        </b-form-select-option>
                        <b-form-select-option value="supervisor">{{
                            $t('message.supervisor')
                          }}
                        </b-form-select-option>
                        <b-form-select-option value="read">{{
                            $t('message.reader')
                          }}
                        </b-form-select-option>
                      </b-select>
                    </div>
                    <div class="col-2 col-sm-2" style="border: 0;position: relative"
                         v-if="canEdit && user.id != record.user.id">
                      <i @click="openDeleteModal(record)"
                         style="margin: 0;color: red;cursor: pointer;position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%)"
                         class="fa fa-trash-o"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import UsersModal from "@/pages/Projects/ProjectTeam/UsersModal";
import DeleteModal from "@/pages/Shared/DeleteModal";
import ConfirmModal from "../Shared/ConfirmModal";

export default {
  components: {DeleteModal, UsersModal, ConfirmModal},
  data() {
    return {
      project: null,
      steps: [],
      stepSelected: null
    };
  },
  async created() {
    this.project = await this.$store.dispatch('projects/getProject', this.$route.params.id)
    this.$store.dispatch('projects/loadInvitedUsers', this.$route.params.id)
  },
  methods: {

    reloadUsers() {
      this.$store.dispatch('projects/loadInvitedUsers', this.$route.params.id)
    },

    requestConfirm(data) {

      this.$store.dispatch('projects/updateRole', {
        record: data.record,
        selected: data.event
      }).then(() => {

      })

    },
    changeRole(record, event) {

      let data = {
        record: record,
        event: event
      }

      this.$refs['change-role-confirm'].openModal(data, this.$t('message.approve_change_role_title'), this.$t('message.approve_change_role_description'), this.$t('message.are_you_sure'), record)

    },

    deleteFromDatabase(item) {
      this.$store.dispatch('projects/removeInvitedUser', item.id).then(() => {
        this.$store.dispatch('projects/loadInvitedUsers', this.$route.params.id)
      })
    },

    openDeleteModal(item) {
      this.$refs['userRemoveModal'].openModal(item, this.$t('message.delete_plan_modal_title'), this.$t('message.delete_this_record'), this.$t('message.are_you_sure'))
    },
    openUserModal() {
      this.$refs.usersModal.openModal()
    },

    setAccess(record) {

      let updateData = {
        id: record.id,
        is_editor: record.is_editor
      }

      this.$store.dispatch('projects/updateRole', updateData)
    }
  },
  computed: {
    users: function () {
      let terms = this.$store.getters['projects/getInvitedUsers']
      return terms
    },
    user() {
      return this.$store.getters['shared/getUser']
    },
    canEdit() {
      return this.$store.getters['projects/canEdit']
    }
  }
};
</script>